import { render, staticRenderFns } from "./ThirdPage.vue?vue&type=template&id=6026c2ad&scoped=true"
import script from "./ThirdPage.vue?vue&type=script&lang=js"
export * from "./ThirdPage.vue?vue&type=script&lang=js"
import style0 from "./ThirdPage.vue?vue&type=style&index=0&id=6026c2ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6026c2ad",
  null
  
)

export default component.exports